import { gql } from "@apollo/client";

export const CHECK_ASSETS_IN_RS = gql`
  query CheckAssetsInRS($asset_serials: [String!]!) {
    checkAssetsInRS(asset_serials: $asset_serials)
  }
`;

export const GET_ASSETS = gql`
  query GetAssets($query: QueryInput, $asset: AssetInput) {
    assets(query: $query, asset: $asset) {
      assets {
        _id
        id
        customer_id
        customer_business_name
        contact_id
        name
        created_at
        updated_at
        asset_serial
        asset_type
        asset_type_id
        make
        model
        service_tag
        warranty
        warranty_type
        warranty_end_date
        warranty_start_date
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
